import { render, staticRenderFns } from "./OriginalDocumentsValidation.vue?vue&type=template&id=0f5d260a&scoped=true"
import script from "./OriginalDocumentsValidation.vue?vue&type=script&lang=js"
export * from "./OriginalDocumentsValidation.vue?vue&type=script&lang=js"
import style0 from "./OriginalDocumentsValidation.vue?vue&type=style&index=0&id=0f5d260a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5d260a",
  null
  
)

export default component.exports